<template>
  <div class="fundings-container">
    <div class="sidemenu d-flex justify-content-center">
      <Sidemenu
          @filtersChanged="handleFiltersChanged"
          :usersList="allUsers"
          :contractTypes="contractType"
          filterType="simulation"
      />
    </div>
    <div class="main-content">
      <el-container>
        <el-header class="my-4 h-auto">
          <h3 class="text-uppercase font-weight-bold">Liste des simulations <span class="title-count">({{ simulationsCount }})</span></h3>
          <Loading :value="100" bar-class="bg-info" v-if="!show"></Loading>
        </el-header>
        <el-main class="ml-3 p-0">
          <DataTable
              :contractType="contractType"
              :dataTable="kanban"
              :pagination="simulations.pagination"
              :loading="isSearching"
              @changePage="handlePageChange"
              @filterData="handleFilterData"
          />
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading';
import DataTable from '../components/DataTable';
import Sidemenu from "@/components/Sidemenu.vue";
import { STATUS_OPTIONS } from "@/utils/statusOptions";

export default {
  name: 'SimulationsList',
  props: ['filter', 'date'],
  components: { Sidemenu, DataTable, Loading },
  data() {
    return {
      show: false,
      kanban: [],
      isSearching: false,
      currentFilters: '',
      currentLimit: 10,
      currentPage: 1,
      simulations: {
        data: [],
        pagination: null
      },
      usersList: [],
      allUsers: [],
      statusOptions: STATUS_OPTIONS
    };
  },
  computed: {
    contractType() {
      return this.$store.getters.getContractTypes;
    },
    simulationsCount() {
      return this.simulations?.pagination?.item_count ?? 0;
    }
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      await this.loadData();
    },
    async handleFiltersChanged(filters) {
      this.currentFilters = filters;
      this.currentPage = 1;
      await this.loadData();
    },
    async handlePageChange(pageInfo) {
      this.currentLimit = pageInfo.size;
      this.currentPage = pageInfo.page;
      await this.loadData();
    },
    async handleFilterData(pageInfo) {
      this.currentLimit = pageInfo.size || this.currentLimit;
      this.currentPage = 1;
      await this.loadData();
    },
    async loadData() {
      this.isSearching = true;
      try {
        this.simulations = await this.getFundings();
        this.usersList = this.extractUsersFromFundings(this.simulations.data);
        this.kanban = this.simulations.data;
        if (this.allUsers.length === 0 || this.usersList.length > this.allUsers.length) {
          this.updateAllUsers(this.usersList);
        }
      } catch (error) {
        console.error('Erreur lors du chargement:', error);
      } finally {
        this.isSearching = false;
      }
    },
    updateAllUsers(newUsers) {
      const existingUserIds = new Set(this.allUsers.map(user => user.id));

      newUsers.forEach(user => {
        if (!existingUserIds.has(user.id)) {
          this.allUsers.push(user);
        }
      });
    },
    extractUsersFromFundings(fundings) {
      if (!fundings?.length) return [];
      const uniqueUsers = new Map();
      fundings.forEach(funding => {
        if (funding.user?.id) {
          const userId = funding.user.id;
          if (!uniqueUsers.has(userId)) {
            uniqueUsers.set(userId, {
              id: userId,
              name: `${funding.user.firstname} ${funding.user.lastname}`
            });
          }
        }
      });
      return Array.from(uniqueUsers.values());
    },
    async getFundings() {
      try {
        const res = await this.$http.get('/api/financement/simulation', {
          params: {
            limit: this.currentLimit,
            page: this.currentPage - 1,
            pagination_data: true,
            sqlfilters: this.currentFilters
          }
        });
        return res.data;
      } catch (error) {
        this.$notify({
          duration: 3000,
          text: error.message,
          type: 'error'
        });
      }
    }
  }
};
</script>

<style scoped>
.sidemenu {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1rem;
  width: 21rem;
  z-index: 1000;
  overflow-y: auto;
}

.main-content {
  width: calc(100% - 28rem);
  margin-left: 23rem;
}

@media (max-width: 768px) {
  .fundings-container {
    flex-direction: column;
  }

  .sidemenu {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: 100%;
    max-height: none;
  }

  .main-content {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }
}
</style>